import { Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { trimStringsInObject } from "app/PatientManagement/ReportPayment/ReportPaymentIndex";
import { CHECK_DATE_REPORT } from "app/appConfig";
import {
  PRODUCT_TYPE_DRUG,
  PRODUCT_TYPE_SUPPLY,
  VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT,
  VALUE_TAB_CONSTRUCTION_MATERIALS_SUPPLY,
} from "app/common/LocalConst";
import {
  getCurrentStaff,
  getDepartmentsUser,
  isAdmin,
  transformDate,
} from "app/common/LocalFunction";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { useStore } from "app/stores";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import moment from "moment";
import { memo, useEffect } from "react";
import * as Yup from "yup";
import ConstructionMaterialsSynthesisList from "./ConstructionMaterialsSynthesisList";
import ConstructionMaterialsSynthesisSearch from "./ConstructionMaterialsSynthesisSearch";
import RequestStoreConstructionPopup from "./Popup/RequestStoreConstructionPopup";
const ConstructionMaterialsSynthesisIndex = () => {
  const {
    searchObject,
    handleChangeFormSearch,
    setCurrentTab,
    currentTab,
    openRequestStoreConstructionMaterialPopup,
    handleOpenRequestStoreConstructionMaterialPopup,
    listSelected,
  } = useStore().treatmentManagementStore.constructionMaterialsSynthesisStore;

  const department = useDefaultDepartment();
  const departmentsUser = getDepartmentsUser();
  const isAdminRole = isAdmin();
  const currentUser = getCurrentStaff();

  useEffect(() => {

    handleChangeFormSearch({
      ...searchObject,
      listDepId: searchObject.listDepId?.length
        ? searchObject.listDepId // đã có thì giữ nguyên
        : isAdminRole
          ? department
            ? [department]
            : []
          : departmentsUser || [],
      performer: searchObject?.performer || currentUser,
    });
  }, [department]);

  const validationSchema = Yup.object().shape({
    listDepId: Yup.array().min(1, "Bắt buộc chọn cơ sở!").nullable(),

    minAmountPaid: Yup.number()
      .nullable()
      .min(0, "Cần thu tối thiểu phải >= 0"),
    maxAmountPaid: Yup.number()
      .nullable()
      .when("minAmountPaid", (min, schema) =>
        min != null
          ? schema.min(min, "Cần thu đến phải lớn hơn hoặc bằng Cần thu từ")
          : schema
      ),
    minTotalBill: Yup.number().nullable().min(0, "Đã thu tối thiểu phải >= 0"),
    maxTotalBill: Yup.number()
      .nullable()
      .when("minTotalBill", (min, schema) =>
        min != null
          ? schema.min(min, "Đã thu đến phải lớn hơn hoặc bằng Đã thu từ")
          : schema
      ),
    orderDateTo: Yup.date()
      .transform(transformDate)
      .typeError("Đến ngày không đúng định dạng!")
      .required("Không được bỏ trống thời gian chỉ định")
      .test(
        "orderDateFrom-orderDateTo",
        "Đến ngày không được trước từ ngày",
        function (value) {
          const { orderDateFrom } = this.parent;
          if (orderDateFrom && value) {
            return moment(value).isSameOrAfter(moment(orderDateFrom), "date");
          }
          return true;
        }
      )
      .nullable()
      .when("orderDateFrom", (orderDateFrom, schema) =>
        orderDateFrom
          ? schema.test(
            "within-config-days",
            `Khoảng thời gian không được vượt quá ${CHECK_DATE_REPORT} ngày`,
            (toDate) => {
              if (!toDate) return false;
              const diff = dayjs(toDate).diff(dayjs(orderDateFrom), "day");
              return diff <= CHECK_DATE_REPORT;
            }
          )
          : schema
      ),
    performDateTo: Yup.date()
      .transform(transformDate)
      .typeError("Đến ngày không đúng định dạng!")
      .test(
        "performDateFrom-performDateTo",
        "Đến ngày không được trước từ ngày",
        function (value) {
          const { performDateFrom } = this.parent;
          if (performDateFrom && value) {
            return moment(value).isSameOrAfter(moment(performDateFrom), "date");
          }
          return true;
        }
      )
      .nullable()
      .when("performDateFrom", (performDateFrom, schema) =>
        performDateFrom
          ? schema.test(
            "within-config-days",
            `Khoảng thời gian không được vượt quá ${CHECK_DATE_REPORT} ngày`,
            (toDate) => {
              if (!toDate) return true;
              const diff = dayjs(toDate).diff(dayjs(performDateFrom), "day");
              return diff <= CHECK_DATE_REPORT;
            }
          )
          : schema
      ),
  });

  return (
    <>
      <Formik
        initialValues={{
          ...searchObject,
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const trimmedValues = trimStringsInObject(values);
          handleChangeFormSearch({
            ...trimmedValues,
            pageIndex: 1,
            currentTab,
          });
        }}
        enableReinitialize
      >
        <Form autoComplete="off">
          <section className="cards-container">
            <ConstructionMaterialsSynthesisSearch
              handleOpenRequestStoreConstructionMaterialPopup={
                handleOpenRequestStoreConstructionMaterialPopup
              }
              listSelected={listSelected}
              isAdminRole={isAdminRole}
              departmentsUser={departmentsUser}
            />
            <TabComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
            {openRequestStoreConstructionMaterialPopup && (
              <RequestStoreConstructionPopup />
            )}
          </section>
        </Form>
      </Formik>
    </>
  );
};
const TabComponent = observer(({ currentTab, setCurrentTab }) => {
  return (
    <TabContext value={currentTab}>
      <TabList
        className="tabs-container"
        variant="scrollable"
        // scrollButtons="on"
        onChange={(_, newTabIndex) => {
          setCurrentTab(newTabIndex);
        }}
        value={currentTab}
      >
        {TAB_LIST_CONSTRUCTION.map((tab, index) => (
          <Tab
            key={index}
            className={`item-tabs ${index === currentTab ? "item-tabs-active" : ""
              }`}
            label={tab?.name}
            value={index}
          />
        ))}
      </TabList>

      {TAB_LIST_CONSTRUCTION.map((tab, index) => (
        <TabPanel key={index} value={index} className="p-0 m-0">
          <ConstructionMaterialsSynthesisList />
        </TabPanel>
      ))}
    </TabContext>
  );
});

export const TAB_LIST_CONSTRUCTION = [
  {
    name: "Danh sách sản phẩm",
    value: VALUE_TAB_CONSTRUCTION_MATERIALS_PRODUCT,
    type: PRODUCT_TYPE_DRUG,
  },
  {
    name: "Danh sách vật tư",

    value: VALUE_TAB_CONSTRUCTION_MATERIALS_SUPPLY,
    type: PRODUCT_TYPE_SUPPLY,
  },
];
export default memo(observer(ConstructionMaterialsSynthesisIndex));
